import APIHelper from "helpers/APIHelper";
import React from 'react';
import { useCADState } from "../Context/CADContext";
import useCADHash from "../Context/useCADHash";
import AutoScaleToWidthDiv from "components/OptionsWizard/GenericComponents/AutoScaleToWidthDiv";
import CADDrawing from "./CADDrawing";
import LoadingOverlay from "components/OptionsWizard/GenericComponents/LoadingOverlay";
import { IPoint } from "../interfaces";
import useImageLoader from "helpers/hooks/useImageLoader";
import CADItemAPI from "../API/CADItemAPI";
import useClientID from "helpers/context/Authentication/useClientID";
import { isNullOrWhiteSpace } from "helpers/objects";
import { LayerDisplayEnum } from "../enums";

interface ICADImageProps {
    imageStyle?: React.CSSProperties;
}

const CADImage: React.FC<ICADImageProps> = (props: ICADImageProps) => {

    const cad = useCADState();
    const cadHash = useCADHash(cad.model);
    const clientID = useClientID();
    const currentLayer = cad.currentLayer?.name ?? cad.currentLayer?.name ?? "";

    const uiSelections = cad.model?.uiSelections;

    const imageUrl: string = React.useMemo(() => {
        let url = `api/cad/item/drawing?hash=${cadHash}&includeDimensions=${uiSelections?.showDimensions ?? true}&includeEdgeNumbers=${uiSelections?.showEdgeNumbers ?? true}&layer=${currentLayer}&layerDisplay=${uiSelections?.layerDisplay ?? LayerDisplayEnum.Single}`;
        if (!isNullOrWhiteSpace(clientID)) {
            url += `&clientID=${clientID}`;
        }
        return url;
    }, [cadHash, uiSelections, clientID, currentLayer]);

    const url: string = APIHelper.PrependBaseURL(imageUrl);

    const [loading, loadedImageUrl] = useImageLoader(url);
    const [scale, setScale] = React.useState<number>(1);
    const [offset, setOffset] = React.useState<IPoint>({ x: 0, y: 0 });

    React.useEffect(() => {
        //Wait until url == loadedImageURL to prevent this from firing too early and getting the image data for the wrong cad layer
        if (loadedImageUrl && cadHash && url === loadedImageUrl ) {

            CADItemAPI.GetItemDrawingInfoAsync(uiSelections?.showDimensions ?? false, uiSelections?.showEdgeNumbers ?? false, currentLayer, uiSelections?.layerDisplay ?? LayerDisplayEnum.Single ).then((info) => {
                setScale(info.scalingFactor);
                setOffset(info.offset);
            });
        }
     }, [cadHash, uiSelections, currentLayer, loadedImageUrl]);

    if (cadHash) {

        return <>
            <AutoScaleToWidthDiv>

                <LoadingOverlay loading={loading}>
                    {loadedImageUrl ?
                        <CADDrawing
                            loadedImageUrl={loadedImageUrl}
                            imageScale={scale}
                            imageOffset={offset}
                        />
                        :
                        <div style={props.imageStyle} />
                    }
                </LoadingOverlay>

            </AutoScaleToWidthDiv>
        </>

    } else {
        return <></>;
    }

}

export default CADImage;